"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectIndent = void 0;
function detectIndent(root) {
    if (root.raws.indent)
        return root.raws.indent;
    let detectedIndent = '    ';
    root.walk(node => {
        let p = node.parent;
        if (p && p !== root && p.parent && p.parent === root) {
            if (typeof node.raws.before !== 'undefined') {
                let parts = node.raws.before.split('\n');
                detectedIndent = parts[parts.length - 1];
                detectedIndent = detectedIndent.replace(/\S/g, '');
                return false;
            }
        }
    });
    return detectedIndent;
}
exports.detectIndent = detectIndent;
